import React from 'react';
import { Snackbar, SnackbarOrigin } from '@material-ui/core';

import Notification from './notification';

interface NotificationSnackbarProps {
  severity: 'success' | 'error';
  message: string;
  autoHideDuration?: number;
  anchorOrigin?: SnackbarOrigin;
}

const NotificationSnackbar: React.FC<NotificationSnackbarProps> = ({
  severity,
  message,
  autoHideDuration = 3000,
  anchorOrigin = { vertical: 'top', horizontal: 'right' },
}) => (
  <Snackbar autoHideDuration={autoHideDuration} open anchorOrigin={anchorOrigin}>
    <Notification severity={severity}>{message}</Notification>
  </Snackbar>
);

const renderSuccess = () => (
  <NotificationSnackbar severity="success" message="Alarm updated successfully." />
);

const renderError = (error: { message: string }) => (
  <NotificationSnackbar severity="error" message={error.message} />
);

export { renderSuccess, renderError };
